/**
 * @desc 获取 profile 对应 user 的身份证号码
 */

import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryProfileIdCardParameter = {
  profileId?: string
}

const method = 'GET'
const url = '/auth/profile/idcard'

export const queryProfileIdCardApi = (
  params?: QueryProfileIdCardParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<string>({
    method,
    url,
    params,
    ...config
  })
}

queryProfileIdCardApi.method = method
queryProfileIdCardApi.url = url
